import { Component, Input, OnInit } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import {
  Customer,
  CustomerRelation,
  getRelationTypeDisplay
} from '../../../../../../../models/customer';
import { AccountService } from '../../../../../../../services/account/account.service';
import { OrganizationConfigService } from '../../../../../../../services/organization-config/organization-config.service';
import { CustomerService } from '../../../../../../../services/customer/customer.service';

@Component({
  selector: 'app-confirm-remove-linked-account-modal',
  templateUrl: './confirm-remove-linked-account-modal.component.html',
  styleUrls: ['./confirm-remove-linked-account-modal.component.css']
})
export class ConfirmRemoveLinkedAccountModalComponent implements OnInit {

  @Input() relation: CustomerRelation;
  @Input() customer: Customer;
  @Input() savedCallback: () => undefined;

  public loadingRemoveSubmit = false;
  public errorMessage = '';

  public serverError: number = null;

  // Create instance references to lookup functions and enums so they may be
  // called in the template.
  public getRelationTypeDisplay = getRelationTypeDisplay;

  constructor(
    public accountService: AccountService,
    public activeModal: NgbActiveModal,
    public orgConfigService: OrganizationConfigService,
    private customerService: CustomerService
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().can_manage_members) {
      return;
    }
  }

  public handleRemoveSubmit() {
    this.loadingRemoveSubmit = true;

    this.errorMessage = '';

    this.customerService
      .deleteCustomerRelation(this.relation.url)
      .then(() => {
        this.savedCallback();
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to remove customer links.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingRemoveSubmit = false; });
  }

}
